var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShutdownDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM7.90063 7.90063C8.3237 7.47757 9.00963 7.47757 9.4327 7.90063L13.2629 11.7308L17.093 7.90063C17.5161 7.47757 18.202 7.47757 18.6251 7.90063C19.0482 8.3237 19.0482 9.00963 18.6251 9.4327L14.7949 13.2629L18.6251 17.093C19.0482 17.5161 19.0482 18.202 18.6251 18.6251C18.202 19.0482 17.5161 19.0482 17.093 18.6251L13.2629 14.7949L9.4327 18.6251C9.00964 19.0482 8.32371 19.0482 7.90064 18.6251C7.47757 18.202 7.47757 17.5161 7.90064 17.093L11.7308 13.2629L7.90063 9.4327C7.47757 9.00963 7.47757 8.3237 7.90063 7.90063Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShutdownDevice);
export default __webpack_public_path__ + "static/media/shutdown_device.077f449fc7c148dc87e8f5de9f874f58.svg";
export { ForwardRef as ReactComponent };